const INITIAL_INDEX = 0;

export const initProductSlider = (element) => {
  const pictureElement = element.querySelector(`.js-item-slider-image`);
  const imageElement = pictureElement.querySelector(`img`);
  const webpSourceElement = pictureElement.querySelector(`[type="image/webp"]:not([media="(max-width: 767px)"])`);
  const controls = element.querySelectorAll(`.js-item-slider-control`);
  const dots = element.querySelectorAll(`.js-item-slider-dot`);
  let currentIndex = INITIAL_INDEX;

  const changeSlide = ({index, control}) => {
    if (currentIndex === index) {
      return;
    }

    if (webpSourceElement) {
      webpSourceElement.srcset = control.dataset.webpSrc;
    }

    imageElement.src = control.dataset.src;
    dots[currentIndex].classList.remove(`active`);
    dots[index].classList.add(`active`);
    currentIndex = index;
  };

  const onMouseleaveElement = () => changeSlide({index: INITIAL_INDEX, control: controls[INITIAL_INDEX]});

  if (controls.length && dots.length) {
    controls.forEach((control, index) => {
      const onMouseoverControl = () => changeSlide({index, control});
      control.addEventListener(`mouseover`, onMouseoverControl);
    });

    element.addEventListener(`mouseleave`, onMouseleaveElement);
  }
};

export const productSlider = () => {
  const productSliderElements = document.querySelectorAll(`.js-item-slider`);

  if (productSliderElements.length) {
    productSliderElements.forEach((productSlider) => {
      initProductSlider(productSlider);
    });
  }
};
